/* Minimum quantities for pieces sold in pairs (product field custom.min_qty).
   - Product page: the quantity opens at the minimum and cannot step below it.
     The minimum rides along as a hidden line property (_min_qty), which
     Shopify keeps out of checkout, so the cart drawer knows it too.
   - Cart page and drawer: the minus button stops at the minimum and says why.
     Remove still takes the line out entirely.
   Loaded after bubbly.js, whose steppers floor at 1; this lifts them back. */
(function(){
  var NOTE = 'Sold in pairs, minimum of ';

  // ----- product page -----
  var min = Number(window.BH_MIN_QTY || 0);
  var pdp = document.querySelector('.pdp');
  if (pdp && min > 1) {
    Array.prototype.forEach.call(pdp.querySelectorAll('[data-qty] input[name="quantity"]'), function(i){
      i.min = min;
      if (Number(i.value || 1) < min) i.value = min;
    });
    var form = pdp.querySelector('form[action*="/cart/add"]') || pdp.querySelector('form');
    if (form && !form.querySelector('input[name="properties[_min_qty]"]')) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'properties[_min_qty]';
      h.value = min;
      form.appendChild(h);
    }
    document.addEventListener('click', function(e){
      var down = e.target.closest('[data-qty-down]');
      if (!down || !pdp.contains(down)) return;
      var input = down.parentElement.querySelector('input');
      if (input && Number(input.value) < min) input.value = min;
    });
  }

  // ----- cart page and drawer -----
  var mins = {};
  function minFor(line){
    return Number(line.dataset.min || mins[line.dataset.key] || 0);
  }
  function paintDrawer(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-lines] [data-line]'), function(l){
      var m = mins[l.dataset.key];
      if (!m) return;
      l.dataset.min = m;
      var i = l.querySelector('[data-line-qty] input');
      if (i) i.min = m;
    });
  }
  function refresh(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        mins = {};
        (c.items || []).forEach(function(i){
          var m = Number(i.properties && i.properties._min_qty || 0);
          if (m > 1) mins[i.key] = m;
        });
        paintDrawer();
      })
      .catch(function(){});
  }
  var drawerLines = document.querySelector('[data-cart-lines]');
  if (drawerLines && window.MutationObserver) {
    new MutationObserver(refresh).observe(drawerLines, { childList: true });
  }

  // Runs in the capture phase, ahead of bubbly.js, so a step below the minimum
  // never reaches the cart.
  document.addEventListener('click', function(e){
    var step = e.target.closest('[data-line-step="-1"]');
    if (!step) return;
    var line = step.closest('[data-line]');
    if (!line) return;
    var m = minFor(line);
    if (m < 2) return;
    var input = line.querySelector('[data-line-qty] input');
    var next = Number(input && input.value || 0) - 1;
    if (next > 0 && next < m) {
      e.preventDefault();
      e.stopPropagation();
      var note = line.querySelector('[data-line-note]');
      if (note) { note.hidden = false; note.textContent = NOTE + m; }
    }
  }, true);
})();
